import React from "react";

const WebPages_Folders = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Folders</h1>
      <p>This is the WebPages Folders page content.</p>
    </div>
  );
};

export default WebPages_Folders;
